import React from 'react';
import { write, useSnap } from '../../store'
import toast from 'react-hot-toast';


function RusWriting() {
    const read = useSnap()


    return (

        <>

            <div className="flex flex-col text-justify">


                <p>
                    Письменная часть включает в себя <span className='text-red-600'>{read.user.noq.writing}</span> вопросов, и у вас есть 10 минут, чтобы ответить на каждый из них. Если время истечет, а вы не отправите свой ответ, приложение автоматически перейдет к следующему вопросу.
                </p>
                <br />
                <p>
                    Вы увидите таймер для связанных вопросов в правом верхнем углу приложения, а ваша камера будет записываться в левом верхнем углу. Письменная часть займет <span className='text-red-600'> В ОБЩЕЙ СЛОЖНОСТИ {read.user.noq.writing * 10} минут, чтобы ответить на все вопросы.</span> Пожалуйста, не торопитесь.
                </p>
                <br />
                <p>
                    Вы должны написать не менее <span className='text-red-600'>80</span> слов, чтобы соответствовать приемлемому диапазону нашей оценки. Вы не можете копировать или вставлять любые материалы, большие или маленькие, из любых других источников. Если вы используете ChatGPT или любой другой инструмент ИИ или переводчик, наша система легко это обнаружит, и вы получите 0.
                </p>
                <br />
                <p>
                    Если вы не можете написать, вы можете пропустить вопрос и потерять балл.
                </p>
                <br />
                <p>
                    Ваш монитор, движения и глаза записываются. Вы получите 0, если откроете стороннее приложение или будете жульничать в любой форме.
                </p>
                <br />
                <h1 className=' text-2xl'>
                    Если вы понимаете инструкции, вы можете нажать Я ПОНИМАЮ и начать письменную часть. Удачи!
                </h1>

            </div>

        </>
    )



}


export default RusWriting